import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {CustomerModel} from '../order-to-cash/models-otc/customer-model';

@Injectable({
  providedIn: 'root'
})
export class RecommendationManagerSharedDataService {

  public customerDetailsSubject = new BehaviorSubject<CustomerModel[]>(null);
  public recommendationDetailSubject = new BehaviorSubject<any[]>(null);
  public recommendationSoftTissueSubject = new BehaviorSubject<any>(null);

  constructor() { }

  updateCustomerDetails(customerList: CustomerModel[]): void {
    this.customerDetailsSubject.next(customerList);
  }

  updateRecommendationDetails(recommendationDetails) {
    this.recommendationDetailSubject.next(recommendationDetails);
  }

  updateRecommendationSoftTissueList(softTissueList) {
    this.recommendationSoftTissueSubject.next(softTissueList);
  }
}
